import type { SolarCycleBlend } from "./solar-cycle";
import {
  applySolarThemeTokenOverrides,
  blendSolarThemeTokens,
  clearSolarThemeTokenOverrides,
  getSolarThemeTokens,
} from "./solar-cycle-blend";

export function applySolarCycleBlendToDocument(blend: SolarCycleBlend | null): void {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;

  try {
    if (!blend || blend.progress <= 0 || blend.progress >= 1) {
      clearSolarThemeTokenOverrides(root);
      return;
    }

    const fromTokens = getSolarThemeTokens(blend.from.theme, blend.from.mode);
    const toTokens = getSolarThemeTokens(blend.to.theme, blend.to.mode);

    if (!fromTokens || !toTokens) {
      clearSolarThemeTokenOverrides(root);
      return;
    }

    applySolarThemeTokenOverrides(
      root,
      blendSolarThemeTokens(fromTokens, toTokens, blend.progress)
    );
  } catch (error) {
    // This runs on every route from the app's root provider - a bad blend
    // must fall back to the theme's own colors, never take down the app.
    clearSolarThemeTokenOverrides(root);
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("Solar cycle blend failed, falling back to unblended theme.", error);
    }
  }
}
